import type { ButtonHTMLAttributes, ReactNode } from "react";

// "danger" is reserved for Tier 2 confirmations (spec §7): transparent fill,
// --color-danger border and text. Never use it for a reversible action.
type Variant = "primary" | "secondary" | "ghost" | "danger";

/**
 * The one button in the system. `variant` picks the ANANSI treatment; every
 * other button attribute passes straight through, so `type`, `disabled` and
 * the handlers behave exactly as they do on a bare `<button>`.
 *
 * Use `ButtonLink` when the action navigates — an anchor wrapped around a
 * button is two interactive elements for one action.
 */
export function Button({
  variant = "primary",
  children,
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; children: ReactNode }) {
  return (
    <button className={`btn btn--${variant}${className ? ` ${className}` : ""}`} {...props}>
      {children}
    </button>
  );
}
